import axios from "axios";

export const setNotificationRead = (id, read) =>
  axios.put(`/notification/${id}/${read ? "mark-as-read" : "mark-as-unread"}`);
